module.exports = __webpack_public_path__ + "static/media/stars.ca85a5ad.png";